import { ReactNode } from 'react';

import { EuiButton, EuiEmptyPrompt } from '@elastic/eui';

export const Error = ({
  title,
  description,
  onRefresh,
}: {
  title: string;
  description: ReactNode;
  onRefresh: () => void;
}) => {
  return (
    <EuiEmptyPrompt
      iconType="error"
      color="danger"
      title={<h2>{title}</h2>}
      body={description}
      actions={[
        <EuiButton key="refresh" color="danger" fill onClick={onRefresh}>
          Refresh
        </EuiButton>,
      ]}
    />
  );
};
